import {Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges} from '@angular/core';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { ProjectHolder } from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import { ProjectActivity } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity';
import * as moment from 'moment';
import { ProjectActivityDialogComponent } from '../project-activity-dialog/project-activity-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {
  TaskEditDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';
import { ConfirmationService } from 'primeng/api';
import { KanbanBoardService } from 'projects/desktop/src/app/modules/kanban-board/data/kanban-board.service';
import { KanbanBoardStore } from 'projects/desktop/src/app/modules/kanban-board/data/kanban-board.store';
import { ProjectFile } from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import { TrelloService } from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import { FileService } from '../../../../../../../core/src/lib/misc/data/file/file.service';
import { FileOpenerService } from '../../utils/fileOpener.service';
import { UsersService } from 'projects/app-misc/src/app/modules/users/data/users.service';
import { User } from 'projects/core/src/lib/login/data/user';

@Component({
  selector: 'app-activity-status',
  templateUrl: './activity-status.component.html',
  styleUrls: ['./activity-status.component.scss'],
  providers: [ConfirmationService]
})
export class ActivityStatusComponent implements OnInit, OnChanges {

  project: Project;

  @Input()
  title: string;

  @Input()
  projectActivity: ProjectActivity;

  @Input()
  allActivities: ProjectActivity[];

  @Input()
  currentIndex: number;

  hours: string;

  // TODO FIX THIS WITH AKITA
  activityExist = true;

  assignedUsers: User[] = [];

  @Output() deleteAction = new EventEmitter<ProjectActivity>();

  constructor(
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    private dialog: MatDialog,
    protected projectHolder: ProjectHolder,
    protected confirmationService: ConfirmationService,
    protected kanbanBoardStore: KanbanBoardStore,
    protected kanbanBoardService: KanbanBoardService,
    protected trelloService: TrelloService,
    private projectActivityService: ProjectActivityService,
    protected usersService: UsersService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.countHours();
    this.resolveUsers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.projectActivity && this.projectActivity) {
      this.countHours();
      this.resolveUsers();
    }
  }

  resolveUsers() {
    this.usersService.getActiveUsers().subscribe(activeUsers => {
      const allUsers: User[] = [];
      if (this.projectActivity.user) {
        allUsers.push(this.projectActivity.user);
      }
      if (this.projectActivity.additionalUsers) {
        this.projectActivity.additionalUsers.forEach(id => {
          const found = activeUsers.find(u => u.id === id);
          if (found) {
            allUsers.push(found);
          }
        });
      }

      const uniqueUsers = [];
      const ids = new Set();
      for (const u of allUsers) {
        if (!ids.has(u.id)) {
          ids.add(u.id);
          uniqueUsers.push(u);
        }
      }

      this.assignedUsers = uniqueUsers;
    });
  }

  get visibleUsers(): User[] {
    if (this.assignedUsers.length > 5) {
      return this.assignedUsers.slice(0, 4);
    }
    return this.assignedUsers;
  }

  get hiddenUsersTooltip(): string {
    if (this.assignedUsers.length > 5) {
      return this.assignedUsers.slice(4).map(u => u.name).join(', ');
    }
    return '';
  }

  toggleReady() {
    if (this.projectActivity.startDate) {
      this.projectActivity.ready = !this.projectActivity.ready;

      this.projectActivityService
        .saveProjectActivity({
          id: this.projectActivity.id,
          ready: this.projectActivity.ready
        })
        .subscribe(() => {
        }, error => {
          this.projectActivity.ready = !this.projectActivity.ready;
        })
    }

  }


  moveCard() {
    if (this.project.card && this.project.card.list) {
      const DELIVERYCOLUMNID = 9;
      const oldColId = this.project.card.list.id

      this.kanbanBoardService.moveCard(this.project.card.id, DELIVERYCOLUMNID, 0).subscribe(card => {

        this.kanbanBoardService.projectRemove.emit({
          columnId: oldColId,
          projectId: this.project.id
        });

        this.kanbanBoardService.projectInsert.emit({
          columnId: DELIVERYCOLUMNID,
          project: this.project,
          index: 0
        });

        this.kanbanBoardStore.updateActiveColumnId(DELIVERYCOLUMNID)
      })
    }
  }

  countHours() {
    const now = moment()
    const b = moment(now).add(this.projectActivity.duration, 'seconds')
    this.hours = b.diff(now, 'hours') + 'h'
  }


  editProjectActivity(): void {
    this.projectActivityService.getActivityTypes().subscribe(types => {
      const activityTypes = types

      const dialogRef = this.dialog.open(ProjectActivityDialogComponent, {
        data: { projectActivity: this.projectActivity, buttonLabel: 'Save', types: activityTypes },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result && result.id) {
          this.projectActivity = result;
          this.countHours();
        }
      });

    })
  }

  editTask(event) {
    event.stopPropagation();

    this.projectActivity.workOrderTask.clazz = 'SERVICE_ORDER_TASK';

    const dialogRef = this.dialog.open(TaskEditDialogComponent, {
      data: {
        task: this.projectActivity.workOrderTask,
        buttonLabel: 'Save'
      },
      panelClass: 'task-edit-dialog',
      disableClose: false
    });
  }

  openFile(event, projectFile: ProjectFile) {
    event.stopPropagation();

    this.fileOpenerService.openFile(projectFile, this.projectActivity.files, true)
  }

  get nestingLevel(): number {
    if (!this.allActivities || this.currentIndex === undefined) {
      return this.projectActivity.type?.level || 0;
    }

    const uniqueLevels = this.allActivities
      .map(activity => activity.type?.level || 0)
      .filter((level, index, arr) => arr.indexOf(level) === index)
      .sort((a, b) => a - b);

    const currentLevel = this.projectActivity.type?.level || 0;
    return uniqueLevels.indexOf(currentLevel);
  }

  get shouldShowGuide(): boolean {
    if (!this.allActivities || this.currentIndex === undefined || this.currentIndex === 0) {
      return false;
    }

    const currentLevel = this.projectActivity.type?.level || 0;
    const prevLevel = this.allActivities[this.currentIndex - 1]?.type?.level || 0;

    return currentLevel > 0 && currentLevel > prevLevel;
  }
}
